import React from 'react';
import Button from '../../components/UI/Button';

import css from './VerifyFunding.module.scss';

interface Props {
  onClickOk: () => void;
}

const MaxAttemptsModal = ({ onClickOk }: Props) => {
  return (
    <div className={css.openModal} data-testid="max-attempts-modal">
      <div className={css.modal}>
        <p className={css.modalHeader}>
          We weren’t able to verify your funding account yet, but we’ll help you
          out in a bit.
        </p>
        <br />
        <p>
          Don’t worry, it’s probably something simple that we can figure out.
        </p>
        <p>
          Let’s finish the last step of registration and get you into the app.
          Then we can give you more help getting your funding account set up.
        </p>
        <Button text="Ok" onClick={onClickOk} />
      </div>
    </div>
  );
};

export default MaxAttemptsModal;
